import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  searchContainer: {
    paddingLeft: '15px',
    marginBottom: '15px',
  },

  searchField: {
    borderRadius: '4px',
  },
})

export const SearchBar = ({ search, setSearch }) => {
  const [value, setValue] = useState(search)
  const classes = useStyles()

  const onChange = (event) => {
    setValue(event.target.value)
  }

  const handleSearch = (event) => {
    if (event.keyCode === 13) {
      setSearch(value)
    }
  }

  return (
    <div className={`${classes.searchContainer} row`}>
      <div className="col-md-12 margin-vert-10">
        <input
          placeholder="Search Users"
          value={value}
          onChange={onChange}
          onKeyDown={handleSearch}
          className={`${classes.searchField} form-control`}
          type="text"
        />
      </div>
    </div>
  )
}
